import ErrorPage from 'components/ErrorPage'
import PageHeader from 'components/PageHeader'
import SegmentDetails from 'components/SegmentDetails'
import Spinner from 'components/Spinner'
import useSegmentCampaign from 'hooks/useSegmentCampaign'
import { useSegmentDetails } from 'hooks/useSegmentDetails'
import { buildTranslate } from 'locales'
import { Container } from 'react-bootstrap-five'
import Helmet from 'react-helmet'
import { Redirect, RouteComponentProps } from 'react-router-dom'
import NewSegmentCampaignModal from 'scenes/CampaignCenter/Landing/NewSegmentCampaignModal'
import SegmentDescription from 'scenes/Segments/SegmentPage/SegmentDescription'

interface SegmentPageProps extends RouteComponentProps<{ segmentId: string }> {}

const t = buildTranslate('segments.segment_page')

const SegmentPage = (props: SegmentPageProps) => {
  const { match } = props
  const { segmentId } = match.params

  const {
    showModal,
    selectedSegment,
    openCampaignModal,
    closeModal,
    createCampaign,
  } = useSegmentCampaign()

  const {
    data: { segment },
    loading: { any: isLoading },
    error: { any: error },
  } = useSegmentDetails({
    segmentId,
    // SampleCustomers fetches its own paginated copy; a second one here would
    // only hold the page spinner for data nothing reads.
    enableSampleCustomers: false,
  })

  const handleCreateCampaign = () => {
    if (segment) {
      openCampaignModal(segment)
    }
  }

  if (isLoading) {
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ minHeight: '400px' }}
      >
        <Spinner
          className="d-flex justify-content-center"
          size="3x"
          isLoading={isLoading}
        />
      </div>
    )
  }

  if (error || !segment) {
    return <ErrorPage dataTestId="segment-error-page" />
  }

  if (segment.type === 'user_list') {
    return <Redirect to={`/user_lists/${segment.id}`} />
  }

  return (
    <>
      <Helmet>
        <title>{t('page_title', { segment_name: segment.name })}</title>
      </Helmet>

      <PageHeader
        backPath={window.history.length <= 1 ? undefined : '/segments'}
        title={segment.name}
        description={<SegmentDescription segment={segment} />}
        buttonAction={handleCreateCampaign}
        buttonText={t('create_campaign_button')}
      >
        <Container>
          <SegmentDetails segment={segment} id="segment-page-tabs" />
        </Container>
      </PageHeader>

      <NewSegmentCampaignModal
        isOpen={showModal}
        onClose={closeModal}
        segment={selectedSegment}
        onCreate={createCampaign}
      />
    </>
  )
}

export default SegmentPage
